import {AppAutoComplete} from 'components/form';
import {SelectOptionsType} from 'global';
import {useMoveItemToStatus} from 'hooks';
import {ItemStatus} from 'models/board';
import React, {useEffect, useMemo, useState} from 'react';

interface TableViewStatusSelectProps {
    statuses: ItemStatus[];
    selectedStatus: ItemStatus | null;
    itemDataId: string;
}

const TableViewStatusSelect: React.FC<TableViewStatusSelectProps> = ({statuses, selectedStatus, itemDataId}) => {
    const [selectedOption, setSelectedOption] = useState<SelectOptionsType>(
        selectedStatus
            ? {
                  label: selectedStatus.title,
                  value: selectedStatus.id,
              }
            : {label: '', value: ''},
    );
    const statusOptions: SelectOptionsType[] = useMemo(() => {
        return statuses.map(status => ({
            label: status.title,
            value: status.id,
        }));
    }, [statuses]);

    const {moveItemToStatus, moveItemToStatusLoading} = useMoveItemToStatus();

    const handleStatusChange = (option: SelectOptionsType | null) => {
        if (!option) return;
        moveItemToStatus({
            variables: {
                input: {
                    itemIds: [itemDataId],
                    itemStatusId: option.value,
                },
            },
        });
        setSelectedOption(option);
    };

    return (
        <AppAutoComplete
            options={statusOptions}
            value={selectedOption}
            clearIcon={false}
            loading={moveItemToStatusLoading}
            isOptionEqualToValue={(option, value) => option.label === value.label}
            onChange={(e, value) => {
                e.stopPropagation();
                e.preventDefault();
                handleStatusChange(value);
            }}
        />
    );
};

export default TableViewStatusSelect;
